import processEditor from '../../process-editor'
import config from './config';
let sketch;
let i = 0;
let tools={
  hand: i++,
  marquee: i++
}
export default {
  name:'MwProcessChartEditor',
  render(){
    let {zoomOut,zoomIn,zoomDefault,editable,clear,color,changeHand,changeMarquee}=this;
    let leftHtml='';
    let cls='mw-process-chart-body mw-process-chart-body-readonly';
    let clearBtn='';
    let colorHtml='';
    let toolsHtml=<label><input type="checkbox" name="sketchMode" onClick={(event)=>changeMarquee(event)}/>&nbsp;<span class='ydhb'>{$lang('移动画布')}</span>&nbsp;&nbsp;&nbsp;</label>
    if(color){
      colorHtml=<div class="__char_color">
        <i class="fa fa-square" style="color:#999999"></i><span>{$lang('未办')}</span>
        <i class="fa fa-square" style="color:#67bc69"></i><span>{$lang('已办')}</span>
        <i class="fa fa-square" style="color:#fb3500"></i><span>{$lang('在办')}</span>
        <i class="fa fa-square" style="color:#fba500"></i><span>{$lang('待办')}</span>
      </div>
    }else{
      //toolsHtml=<label><input type="checkbox" name="sketchMode" onClick={(event)=>changeMarquee(event)}/>&nbsp;{$lang('移动画布')}&nbsp;&nbsp;&nbsp;</label>
    }

    if(editable){
      leftHtml=<div class="__char_left">
        <ul>
          <li>
            <a class="fa fa-play-circle _task" data-type="start" data-name="开始" href="javascript:void(0)" draggable="true" ></a>
            <p>开始任务</p>
          </li>
          <li>
            <a class="fa fa-user _task" data-type="normal" data-name="新增节点" href="javascript:void(0)" draggable="true"></a>
            <p>普通任务</p>
          </li>
          <li>
            <a class="fa fa-ellipsis-h _task" data-type="serial" data-name="新增节点" href="javascript:void(0)" draggable="true"></a>
            <p>串行任务</p>
          </li>
          <li>
            <a class="fa fa-sliders _task" data-type="parallel" data-name="新增节点" href="javascript:void(0)" draggable="true"></a>
            <p>并行任务</p>
          </li>
          <li>
            <a class="fa fa-code-fork _task" data-type="sub-proc" data-name="新增节点" href="javascript:void(0)" draggable="true"></a>
            <p>子流程</p>
          </li>
          <li>
            <a class="fa fa-paw _task" data-type="circular" data-name="新增节点" href="javascript:void(0)" draggable="true"></a>
            <p>传阅</p>
          </li>
          <li>
          <a class="fa fa-paw _task" data-type="dynamic" data-name="自由节点" href="javascript:void(0)" draggable="true"></a>
          <p>自由节点</p>
          </li>
          <li>
            <a class="fa fa-stop-circle _task" data-type="end" data-name="结束" href="javascript:void(0)" draggable="true"></a>
            <p>结束任务</p>
          </li>
        </ul>
      </div>;
      cls='mw-process-chart-body';
      clearBtn=<button  class="el-button el-button--primary" onClick={clear}><i class="fa fa-trash-o"></i>清除</button>;
    }
    return (
      <div class={cls}>
        {leftHtml}
        <div class="__char_toolbar">
          {toolsHtml}
          <button  class="el-button el-button--default" onClick={zoomIn}><i class="fa fa-search-plus"></i>{$lang('放大')}</button>
          <button  class="el-button el-button--default" onClick={zoomOut}><i class="fa fa-search-minus"></i>{$lang('缩小')}</button>
          <button  class="el-button el-button--default" onClick={zoomDefault}><i class="fa fa-refresh"></i>{$lang('原始')}</button>

          {clearBtn}
        </div>

        {colorHtml}
        <svg xmls="http://www.w3.org/2000/svg"  version="1.1" class="__char_body"></svg>
      </div>);
  },
  props:{
    editable: {default: false, type:Boolean},
    designable:{default: false, type:Boolean},
    color:Array,
    observer:{
      type:Object
    },
    value: Object,
    activityTypes: Array
  },
  data() {
    return {
      data: undefined,
      eventId: Math.random()
    }
  },
  mounted(){
    let me=this;
    PF.requireJs("/assets/js/svg/snap.svg.js",()=>{
      let svg = me.$el.querySelector(".__char_body");

      sketch = new Sketch(svg);

      sketch.on('requestTitle', (shape, resolver) => {
        this.$emit('requestTitle', shape, resolver);
      });

      sketch.applyDefault();

      if(!me.editable){
        sketch.mode=51;
      }else{
        sketch.mode=255;
      }
      sketch.tool = tools.marquee;
      sketch.typeNameVisible=me.designable;

      if(me.observer){
        sketch.on('createShape', (v) => {
          me.observer.$emit('node:append',v);
        });
        sketch.on('focusShape', (v) => {
          me.observer.$emit('node:click',v);
        });
        sketch.on('removeShape', (v) => {
          me.observer.$emit('node:remove',v);
        });
        sketch.on('updateLine', (v) => {
          me.observer.$emit('line:update',v);
        });
        sketch.on('createLine', (v) => {
          me.observer.$emit('line:append',v);
        });
        sketch.on('focusLine', (v) => {
          me.observer.$emit('line:click',v);
        });
        sketch.on('removeLine', (v) => {
          me.observer.$emit('line:remove',v);
        });
        sketch.on('blur', (v) => {
          me.observer.$emit('backdrop:click',v);
        });

        me.observer.$on("updateShape",(v) => {
          sketch.updateShape(v);
        })
        me.observer.$on("updateLine",(v) => {
          sketch.updateLine(v,true);
        })


        let dataType,dataName;

        $(this.$el).delegate("._task",'mousedown', function (e) {
           dataType=e.currentTarget.getAttribute('data-type');
           dataName=e.currentTarget.getAttribute('data-name');
        })

        $(this.$el).delegate(".__char_body",'dragover', function (e) {
          for (var el = e.target; el && el.nodeType === 1; el = el.parentNode) {
            if (el === svg) {
              e.preventDefault()
              sketch.requestAutoScroll(e.clientX, e.clientY)
              break
            }
          }
        })
        $(this.$el).delegate(".__char_body",'drop', function (e) {
          for (var el = e.target; el && el.nodeType === 1; el = el.parentNode) {
            if (el === svg) {
              var matrix = sketch.matrix
                , snapMatrix = Snap.matrix.apply(Snap.matrix, matrix).invert()
                , box = svg.getBoundingClientRect()
                , x = e.clientX - box.left
                , y = e.clientY - box.top
                , tx = snapMatrix.x(x, y)
                , ty = snapMatrix.y(x, y)
              sketch.createShape({
                type: dataType,
                matrix: [1, 0, 0, 1, tx, ty],
                name: dataName
              })
              break
            }
          }
        })

        $(document.body).on(`dragend.${this.eventId}`, e => {
          sketch.cancelAutoScroll();
        })

      }
      if(me.value){
        sketch.data=me.value;
      }
      if(me.color){
        sketch.setColor(me.color);
        sketch.mode=17;
      }
    });
  },
  deactivated(){
    this.clearChart();
  },
  beforeDestroy(){
    this.clearChart();
  },
  methods:{
    clear(){
      let me=this;
      sketch.clear();
      me.observer.$emit("clear");
    },

    changeMarquee(event){

      if(!event.target.checked)
        sketch.tool = tools.marquee;
      else
        sketch.tool = tools.hand;
    },

    zoomIn(){
      sketch.zoomIn();
    },
    zoomDefault(){
      sketch.zoomDefault();
    },
    zoomOut(){
      sketch.zoomOut();
    },

    clearChart(){
      sketch.destroy();
    },
    setData(data){
      sketch.data=data;
    },
    getData(){
      return sketch.data;
    },
    addEvent(){

    }
  },
  watch:{
    value(val, oldVal){
      let me=this;
      me.setData(val);
    },
    editable(val, oldVal){
      if(!val){
        sketch.mode=51;
      }else{
        sketch.mode=255;
      }
    },
    designable(val, oldVal){
      sketch.typeNameVisible=val;
    },
    color(val, oldVal){
      sketch.setColor(val);
    }
  },
  errorCaptured(err, component, info){
    console.error(`--%c MwProcessChart%c error: %o`, 'color:green', null, err);
  }
}



// WEBPACK FOOTER //
// ./src/common/components/extend/process-chart-editor/index.js